import gql from 'graphql-tag';

export const UPSERT_AFTERMARKET_DOCUMENT = gql`
  mutation UpsertAftermarketProductDocument($input: UpsertAftermarketProductDocumentInput!, $file: Upload!) {
    upsertAftermarketProductDocument(input: $input, file: $file)
  }
`;
